import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { filtersService } from '../../services/api';
import { Filters, FilterOption } from '../../types/filters';

interface FiltersState {
    items: {
        genders: FilterOption[];
        holidays: FilterOption[];
        compilation: FilterOption[];
    };
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    appliedFilters: {
        genders: number[];
        holidays: number[];
        compilations: number[];
    };
}

const initialState: FiltersState = {
    items: {
        genders: [],
        holidays: [],
        compilation: [],
    },
    status: 'idle',
    error: null,
    appliedFilters: {
        genders: [],
        holidays: [],
        compilations: [],
    },
};

export const fetchFilters = createAsyncThunk(
    'filters/fetchFilters',
    async () => {
        const response = await filtersService.getFilters();
        return response;
    }
);

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<FiltersState['items']>) => {
            state.items = action.payload;
        },
        setAppliedFilters: (state, action: PayloadAction<FiltersState['appliedFilters']>) => {
            state.appliedFilters = action.payload;
        },
        resetFilters: (state) => {
            state.appliedFilters = initialState.appliedFilters;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilters.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
            })
            .addCase(fetchFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'Failed to fetch filters';
            });
    },
});

export const { setFilters, setAppliedFilters, resetFilters } = filtersSlice.actions;
export default filtersSlice.reducer; 